import { render } from "./TalkSection.vue?vue&type=template&id=5dcab718&scoped=true"
const script = {}

import "./TalkSection.vue?vue&type=style&index=0&id=5dcab718&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcab718"]])

export default __exports__